<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-04-28 12:08 -->
<!-- Description: -->
<template>
  <form class="" @submit.prevent="save()">
    <h4>ELIMINAR PERFILES DUPLICADOS DE PACIENTES</h4>
    <div class="row mb-3">
      <div class="col">
        <legend>Nombre del Cliente</legend>
        <ClientSelect ref="elClientSelectRef" v-model="client_ref_id"></ClientSelect>
        <PatientProfileResume v-if="client_ref_id" :key="client_ref_id" :client_id="client_ref_id"></PatientProfileResume>
      </div>
      <div class="col">
        <legend>Duplicado</legend>
        <ClientSelect ref="elClientSelect" v-model="client_id"></ClientSelect>
        <PatientProfileResume v-if="client_id" :key="client_id" :client_id="client_id"></PatientProfileResume>
      </div>
    </div>
    <div class="row">
      <div class="col text-center">
        <button class="btn btn-primary" :disabled="sending">Eliminar Duplicado</button>
      </div>
    </div>
  </form>
</template>
<script>
import ClientSelect from "../../lt/store-module/clients/Select.vue";
import PatientProfileResume from "./PatientProfileResume.vue";
import DentalClinicService from "../DentalClinicService.js";

// script content
export default {
  name: "PatientDeleteDuplicate",
  components: {
    ClientSelect,
    PatientProfileResume,
  },

  // directives

  props: {
    //
  },

  data: () => ({
    client_ref_id: null,
    client_id: null,
    sending: false,
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    async save() {
      if(this.client_ref_id == this.client_id) {
        window.alert("Son el mismo cliente");
        return;
      }
      this.sending = true;
      await DentalClinicService.cancelClientDuplicate({
        client_ref_id: this.client_ref_id, 
        client_id: this.client_id, 
      });
      this.$refs.elClientSelectRef.reset();
      this.$refs.elClientSelect.reset();
      this.client_ref_id = null;
      this.client_id = null;
      this.sending = false;
      window.alert("Se realizo el proceso.")
    },
    //
    //
  }
};
</script>
<style scoped></style>
